import React,{useEffect} from 'react';
import './Dec6_Home_PYG_CSS.css';
import {Dec6_Home_PYG_Container_H_Text} from '../TextFiles/Dec6_Home_TextFiles';
import {Grid, Container} from "@material-ui/core";
import Aos from 'aos';
import 'aos/dist/aos.css'; 

function Dec6_Home_PYG() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []); 

    return(
        <>

        <Grid container justify="center" alignItems="center" className="Dec6_PYG_Grid">
        <Grid item lg={12} sm={12} md={12} xs={12} className="Dec6_PYG_Grid1"  >
        <div data-aos="fade-up" data-aos-once = "true" className="Dec6_Home_PYG_Container">
            <div className="Dec6_Home_PYG_Container_BGColor">
                <h3 data-aos="fade-left"
                    data-aos-delay="120"
                    data-aos-once = "true"
                    className="Dec6_Home_PYG_Container_H1">
                    {Dec6_Home_PYG_Container_H_Text[0]}
                </h3>
                <h3 data-aos="fade-right"
                    data-aos-delay="250"
                    data-aos-once = "true"
                    className="Dec6_Home_PYG_Container_H2">
                    {Dec6_Home_PYG_Container_H_Text[1]}
                </h3>
            </div>
        </div>
        </Grid>
        </Grid>
        </>
    );
}

export default Dec6_Home_PYG;